import VehicleMarksService from '@/api/VehicleMarksService.js'
import StorageFileService from '@/api/StorageFileService'
import Vue from 'vue'
export const vehicleMarksModule = {
  namespaced: true,
  state: () => ({
    vehicleMarks: [],
    loadStatus: ''
  }),

  getters: {},
  mutations: {
    create_one(state, data) {
      state.vehicleMarks = data
    },
    get_all(state, data) {
      state.vehicleMarks = data
    },
    edit_one(state, data) { },
    delete_one(state, data) {
      //   let indexed = state.vehicleTypeAndCharacteristics.findIndex(x => x.vehicle_examples__id == data)
      //
      //   state.vehicleTypeAndCharacteristics.splice(indexed, 1)
    },
    load_request(state, status) {
      state.loadStatus = 'request'
    },
    load_success(state) {
      state.loadStatus = 'success'
    },
    load_error(state) {
      state.loadStatus = 'error'
    }
  },
  actions: {
    createOneMark({ commit, dispatch, rootState }, newData) {
      StorageFileService.upload(newData)
        .then((data) => {
          VehicleMarksService.create({
            vehicle_marks__name: newData.newName,
            vehicle_marks__logo: data.data.data.id
          })
            .then((data) => {
              Vue.$toast.success('Данные сохранены')
              dispatch('getAllMarks', { limit: 10000 })
              // commit("edit_one", data.data.data.rows);
            })
            .catch((error) => {
              Vue.$toast.error(error.response.data.message, { duration: 5000 })
              // commit("load_error");
            })
        })
        .catch((error) => {
          Vue.$toast.error('При сохранении изображения возникла ошибка.', { duration: 5000 })
          commit('load_error')
        })
    },
    editOne({ commit }, payload) {
      VehicleMarksService.update(payload.id, payload.data)
        .then((data) => {
          // commit("edit_one", data.data.data.rows);

          dispatch('getAllMarks', { limit: 10000 })
          commit('load_success')
        })
        .catch((error) => {
          commit('load_error')
        })
    },
    getAllMarks({ commit }, params) {
      commit('load_request')
      VehicleMarksService.getAll(params)
        .then((data) => {
          commit('get_all', data.data.data)
          commit('load_success')
        })
        .catch((error) => {
          commit('load_error')
        })
    },
    deleteOne({ commit }, params) {
      VehicleTypeAndCharacteristicsService.deleteOne(params)
        .then((data) => {
          commit('delete_one', params)
          Vue.$toast.success('Данные удалены')
          dispatch('getAllMarks', { limit: 10000 })
        })
        .catch((error) => {
          commit('load_error')
        })
    }
  }
}
